<script setup lang="ts">
  const { loggedIn } = useUserSession()

  // Redirect if already logged in
  if (loggedIn.value) {
    navigateTo('/todos')
  }

  const form = reactive({
    name: '',
    email: '',
    password: '',
    confirmPassword: '',
  })

  const pending = ref(false)
  const error = ref('')

  async function register() {
    try {
      pending.value = true
      error.value = ''
      if (form.password !== form.confirmPassword) {
        error.value = 'Passwords do not match'
        return
      }

      await $fetch('/api/auth/register', {
        method: 'POST',
        body: {
          name: form.name,
          email: form.email,
          password: form.password,
        },
      })

      await navigateTo('/todos')
    } catch (err: any) {
      error.value = err.data?.message || 'Registration failed'
    } finally {
      pending.value = false
    }
  }
</script>

<template>
  <div class="max-w-md mx-auto">
    <h1 class="text-2xl font-bold mb-6">Sign Up</h1>

    <form @submit.prevent="register" class="space-y-4">
      <UFormGroup label="Name">
        <UInput v-model="form.name" type="text" placeholder="Enter your name" />
      </UFormGroup>

      <UFormGroup label="Email">
        <UInput
          v-model="form.email"
          type="email"
          placeholder="Enter your email"
          required
        />
      </UFormGroup>

      <UFormGroup label="Password">
        <UInput
          v-model="form.password"
          type="password"
          placeholder="Enter your password"
          required
        />
      </UFormGroup>

      <UFormGroup label="Confirm Password">
        <UInput
          v-model="form.confirmPassword"
          type="password"
          placeholder="Confirm your password"
          required
        />
      </UFormGroup>

      <UAlert
        v-if="error"
        color="error"
        variant="soft"
        :title="error"
        class="mb-4"
      />

      <UButton type="submit" :loading="pending" block> Sign Up </UButton>
    </form>

    <div class="mt-6 text-center">
      <p class="text-sm text-gray-600">
        Already have an account?
        <NuxtLink to="/login" class="text-primary-600 hover:text-primary-500">
          Login
        </NuxtLink>
      </p>

      <UDivider label="or" class="my-4" />

      <UButton
        to="/api/auth/github"
        icon="i-simple-icons-github"
        label="Continue with GitHub"
        color="neutral"
        variant="outline"
        external
        block
      />
    </div>
  </div>
</template>
